/* eslint-disable react/default-props-match-prop-types */
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';
import { Link, Button } from 'reaxl';
import { defaultBudgetPrice } from '@/constants';
// Components
import BrowseByMakeModal from './BrowseByMakeModal';
import BrowseByStylesModal from './BrowseByStylesModal';
import { callToActionAnalytics } from '@/analytics';
import { paymentsDuck } from '@/ducks';

const advanceSearchURL = '/cars-for-sale/advanced-search';

const handleMyWalletClick = (dispatch, paymentsInfo) => {
    const {
        budget,
    } = paymentsInfo;

    if (budget === null || budget === 0 || budget === '0') {
        dispatch(paymentsDuck?.creators?.updatePaymentsInfo({
            budget: defaultBudgetPrice, // MyWalletContainer defaults value to 0
        }));
    }
    dispatch(paymentsDuck?.creators?.updateMyWallet({
        displayModal: true,
        selectedPanelName: 'budget',
    }));
};

const getButtonTitle = (listingType) => {
    switch (typeof listingType === 'string' && listingType?.toLowerCase()) {
        case 'new':
            return 'Shop New Cars';
        case 'certified':
            return 'Shop Certified Cars';
        default:
            return 'Shop Used Cars';
    }
};

export const handleSearchByBudgetLinkClick = (e, analyticsPageType, dispatch, paymentsInfo) => {
    callToActionAnalytics.fireBrowsByBudgetClick(e, { pageType: analyticsPageType });
    handleMyWalletClick(dispatch, paymentsInfo);
};

function BrowseByLinks({
    classNames,
    listingType,
    styleCodes,
    analyticsPageType,
    enableBrowseByBudgetLink = false, // only true on HP
    zipCode,
    dealerId,
}) {
    const dispatch = useDispatch();

    const paymentsInfo = useSelector(paymentsDuck.selectors.getPaymentsInfo) || {};

    const handleAdvancedSearchLinkClick = (e) => {
        callToActionAnalytics.fireAdvancedSearchLink(e, { pageType: analyticsPageType });
    };

    const [showStyles, setShowStyles] = useState(false);
    const showHideToggleStylesCallback = (e) => {
        if (!showStyles) {
            callToActionAnalytics.fireBrowseByStyle(e, { pageType: analyticsPageType, zip: zipCode, dealerId });
        }
        setShowStyles(!showStyles);
    };

    const [showMakes, setShowMakes] = useState(false);
    const showHideToggleMakesCallback = (e) => {
        if (!showMakes) {
            callToActionAnalytics.fireBrowsByMakeClick(e, { pageType: analyticsPageType });
        }
        setShowMakes(!showMakes);
    };

    const wrapperClassName = clsx('text-size-100 text-size-sm-300 text-link text-bold padding-0', classNames);
    const separtor = (<div className="text-size-100 text-size-sm-300 display-inline-block padding-horizontal-0 padding-horizontal-sm-1">&nbsp;|&nbsp;</div>);

    return (
        <div className="display-flex justify-content-left justify-content-sm-end">
            <div className="display-inline-block">
                {enableBrowseByBudgetLink ? (
                    <Button
                        className={wrapperClassName}
                        bsStyle="link"
                        data-qaid="lnk-browseByBudget"
                        title="What Can I Afford?"
                        onClick={(e) => handleSearchByBudgetLinkClick(e, analyticsPageType, dispatch, paymentsInfo)}
                    >
                        What Can I Afford?
                    </Button>
                ) : (
                    <Button
                        className={wrapperClassName}
                        bsStyle="link"
                        data-qaid="lnk-browseByMake"
                        title="Browse by Make"
                        onClick={showHideToggleMakesCallback}
                    >
                        Browse by Make
                    </Button>
                )}
                {separtor}
                <Button
                    className={wrapperClassName}
                    bsStyle="link"
                    data-qaid="lnk-browseByStyle"
                    title={getButtonTitle(listingType)}
                    onClick={showHideToggleStylesCallback}
                >
                    {getButtonTitle(listingType)}
                </Button>
                {separtor}
                <Link
                    className={`${wrapperClassName} padding-vertical-4 align-middle`}
                    data-qaid="adv_srch"
                    href={advanceSearchURL}
                    onClick={handleAdvancedSearchLinkClick}
                >
                    Advanced Search
                </Link>
            </div>
            <BrowseByStylesModal
                showModal={showStyles}
                showHideModalToggleCallback={showHideToggleStylesCallback}
                styleCodes={styleCodes}
                listingType={listingType}
            />
            <BrowseByMakeModal
                showModal={showMakes}
                showHideToggleModalCallback={showHideToggleMakesCallback}
                listingType={listingType}
            />
        </div>
    );
}

BrowseByLinks.propTypes = {
    classNames: PropTypes.string,
    zipCode: PropTypes.string,
    dealerId: PropTypes.string,
    listingType: PropTypes.string,
};

export default BrowseByLinks;
